/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_In_With_SsoInputs */

const en_sign_in_with_sso = /** @type {(inputs: Sign_In_With_SsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with SSO`)
};

const nl_sign_in_with_sso = /** @type {(inputs: Sign_In_With_SsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen met SSO`)
};

/**
* | output |
* | --- |
* | "Sign in with SSO" |
*
* @param {Sign_In_With_SsoInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const sign_in_with_sso = /** @type {((inputs?: Sign_In_With_SsoInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_In_With_SsoInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_sign_in_with_sso(inputs)
	return en_sign_in_with_sso(inputs)
});